import StatSimulator from './StatSimulator';
import StatModel from './StatModel';
import SingletonLoading from '../utils/SingletonLoading';
import {ALERT} from '../model/msg/stat';
import {getClassDefaultStat, getSavedUserStats, getSavedUserStat, deleteUserStat} from './../utils/service';
import {getDatasWithOption, handleApiError} from '../../../utils/service';
import {getLoadingBarTpl, getStatStorageItemTpl} from './../model/tpl/stat';
import {isDefined, isFunction, isString, isNumber, not, isNotDefined, notSingleEle, truthy, falsy, each, allOf, getStatMaxByLevel} from '../../../utils/util';
import {API_DOMAIN_DEFAULT} from '../../../model/model';
import moment from 'moment';

class Stat {
  constructor(options) {
    const _ = this;

    if (isNotDefined(options)) throw new Error('Stat constructor require options object');

    _.option = $.extend({
      deviceType: '',
      wrap: null,
      staticDomain: '',
      apiDomain: API_DOMAIN_DEFAULT,
      isLogin: false,
      global: window
    }, options);

    _.model = StatModel.getInstance();

    _.loading = SingletonLoading.getInstance();

    _.wrap = null;

    _.simulatorWrap = null;
    _.classLayer = null;
    _.storageWrap = null;
    _.displayNoStorageItem = null;

    _.stat = null;

    _.global = _.option.global;
  }

  init() {
    const _ = this;

    _.wrap = $(_.option.wrap);

    if (notSingleEle(_.wrap)) throw new Error('wrap must be single element.');

    _.model.DEVICE_TYPE = _.option.deviceType;

    _.simulatorWrap = $('.wrap-simulator', _.wrap);
    _.classLayer = $('.simulator-select', _.wrap);
    _.storageWrap = $('.simulator-storage', _.wrap);
    _.displayNoStorageItem = $('.nodata', _.wrap);

    _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    _.setLoadingBar();
    _.setBtns();
    _.setClassLayer();

    if (truthy(_.option.isLogin)) {
      // _.showNoStorageItems(false, false);
      _.setStorage();
    }
  }

  setLoadingBar() {
    const _ = this;

    $('.wrap-contents', _.wrap).append(getLoadingBarTpl());

    _.loading.setLoadingBar($('.loadingbar', _.wrap));
    _.loading.end();
  }

  setBtns() {
    const _ = this;

    $('.btn-simulator', _.wrap).on('click', function (evt) {
      evt.preventDefault();

      if (_.getSavedUserStatNum() >= _.model.USER_STAT_NUM_LIMIT) {
        const isConfirmSimulateStat = _.global.confirm(ALERT.SAVE_STAT_LIMIT); // 스탯 세팅 저장은 계정당 최대 6개까지 가능합니다. 새 세팅 결과 저장을 원한다면 기존 저장 내용 삭제 후 이용해주세요. 스탯 세팅을 계속 진행하시겠습니까?

        if (truthy(isConfirmSimulateStat)) {
          _.showClassLayer(true);
          _.showStorage(false);
        }

      } else {
        _.showClassLayer(true);
        _.showStorage(false);
      }
    });

    // before login
    $('.btn-login', _.wrap).on('click', function (evt) {
      evt.preventDefault();

      if (isFunction(_.global.GNBLogin)) _.global.GNBLogin();
    });
  }

  setClassLayer() {
    const _ = this;

    $('.btn-close', _.classLayer).on('click', function (evt) {
      evt.preventDefault();

      _.showClassLayer(false);
      _.showStorage(true);
    });

    // 2022.01 스탯 > 레벨 추가
    $('article ul li', _.classLayer).on('click', function (evt) {
      evt.preventDefault();
      $(".simulator-select-class-article ul li.is-selected").removeClass("is-selected");
      $(this).addClass("is-selected");
    });

    // 2022.01 스탯 > 레벨 추가
    $('.simulator-select-level-article .btn-submit', _.classLayer).on('click', function (evt) {
      evt.preventDefault();
      const classId = $('.simulator-select-class-article ul li[class="is-selected"]').attr('data-class');
      const targetLevel = $('.simulator-select-level-article input[name="targetLevel"]').val();

      if(! classId) {
          alert('클래스를 선택해주세요.');
          return false;
      }
      if(! targetLevel) {
        alert('50~100 사이의 원하는 레벨을 숫자만 입력해 주세요.');
        $('.simulator-select-level-article input[name="targetLevel"]').focus();
        return false;
      }
      if (!isNumber(parseInt(targetLevel)) || ! isNumber(parseInt(targetLevel)) || parseInt(targetLevel) < 50 || parseInt(targetLevel) > 100 ) {
        alert('정확한 레벨을 입력해 주세요.');
        $('.simulator-select-level-article input[name="targetLevel"]').focus();
        return false;
      }

      _.setClassDefaultStat(classId, targetLevel); // 2022.01 스탯 시작 클릭
    });
  }

  setStorage() {
    const _ = this;

    _.setStorageItemsEvent(false);

    const storageListWrap = $('.storage-bundle', _.wrap);
    $('.storage__stat', storageListWrap).remove();

    if (truthy(_.loading.isLoading)) return;

    // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-GET/api/simulator/stat/user
    getSavedUserStats({
      apiDomain: _.option.apiDomain,
      beforeSend: () => _.loading.start()

    }).then((data, textStatus, jqXHR) => {
      console.log('getSavedUserStat - data :', data);
      _.loading.end();

      if (truthy(Array.isArray(data))) {
        if (data.length > 0) {
          // sort by descending date order
          data.sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime());
          // const statMax = _.model.STAT_MAX; // 2019.11

          let mainStat = null, itemsTpl = '';
          each(data, function (item) {

            // 2021.12
            // const statMax = (item.level >= _.model.LEVEL_CHANGE_STAT_MAX ) ? _.model.CHANGED_STAT_MAX : _.model.STAT_MAX;  // 2019.11
            // 2022.01 .level-> .targetLevel
            const statMax = getStatMaxByLevel(parseInt(item.targetLevel), _.model.STAT_MAX_BY_LEVEL);

            item.idx = item.idx;
            item.classId = item.classId;
            item.date = _.getDateStr(item.updateDate);
            item.hp = item.statMetaInfo.hp;
            item.mp = item.statMetaInfo.mp;

            mainStat = item.statMetaInfo.mainStat;

            for (let stat in mainStat) if (mainStat[stat] > statMax) mainStat[stat] = statMax;

            item.percentageSTR = `${(mainStat.STR / statMax) * 100}%`;
            item.percentageDEX = `${(mainStat.DEX / statMax) * 100}%`;
            item.percentageINT = `${(mainStat.INT / statMax) * 100}%`;
            item.percentageWIS = `${(mainStat.WIS / statMax) * 100}%`;
            item.percentageCON = `${(mainStat.CON / statMax) * 100}%`;
            item.percentageCHA = `${(mainStat.CHA / statMax) * 100}%`;

            const itemTplFunc = doT.template(getStatStorageItemTpl(true)),
              itemTpl = itemTplFunc(item);

            itemsTpl += itemTpl;
          });

          storageListWrap.prepend(itemsTpl);

          _.setStorageItemsEvent(true);

          _.showNoStorageItems(false);

        } else {
          _.showNoStorageItems(true);
        }

      } else {
        _.global.alert(ALERT.FAIL_LOAD_SAVED_STAT); // '현재 저장된 스탯 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
      }

    }).catch((err) => {
      _.loading.end();
      if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_LOAD_SAVED_STAT); // '현재 저장된 스탯 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
    });
  }

  setClassDefaultStat(classId, targetLevel) { // 2022.01
    const _ = this;

    if (truthy(_.loading.isLoading)) return;

    console.log("=> Stat.js, classId,targetLevel", classId, targetLevel );

    getClassDefaultStat({
      apiDomain: _.option.apiDomain,
      classId: classId,
      targetLevel: targetLevel,
      beforeSend: () => _.loading.start()

    }).then(function (data, textStatus, jqXHR) {
      console.log('=> Stat.js, setClassDefaultStat() data :', data);

      _.loading.end();

      _.showSimulatorWrap(false);

      _.showClassLayer(false);

      _.setStatSimulator('default', classId, targetLevel, data);

    }).catch(function (err) {
      _.loading.end();

      if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_RESET); // '현재 스탯 초기화를 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
    });
  }

  setStorageItemsEvent(flag) {
    const _ = this,
      items = $('.storage-bundle .storage__stat', _.wrap);

    items.each((index, item) => {
      if (truthy(flag)) {
        $(item).on('click', function (evt) {
          evt.preventDefault();

          if (truthy(_.loading.isLoading)) return;

          _.loading.start();

          const classId = $(item).attr('data-class-id'),
            idx = $(this).attr('data-idx'),
            level = $(this).attr('data-level');

          if ($(evt.target).hasClass('btn-delete')) {
            if (allOf(isString(idx), idx !== '')) {
              const msg = ALERT.TRY_DELETE_STAT({level: level}),
                isConfirmDeleteStat = _.global.confirm(msg); // ${0}Lv 스탯 세팅을 삭제하시겠습니까?

              (isConfirmDeleteStat) ? _.deleteStatSetting(idx) : _.loading.end();
            }

            return;
          }

          // get result call getClassDefaultStat, getSavedUserStat
          // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-GET/api/simulator/stat/:classId/default
          // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-GET/api/simulator/stat/user/:idx
          _.setStatSimulatorByApi(classId, level, idx);
        });

      } else {
        $(item).off('click');
      }
    })
  }

  deleteStatSetting(idx) {
    const _ = this;

    // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-DELETE/api/simulator/stat/user/:idx
    deleteUserStat({
      apiDomain: _.option.apiDomain,
      idx: idx,
      beforeSend: () => _.loading.start()

    }).then((data, textStatus, jqXHR) => {
      _.loading.end();

      if (data.result === 'success') {
        // remove stat item
        $('.storage-bundle .storage__stat', _.option.wrap).filter(function () {
          return $(this).attr('data-idx') === idx;
        }).remove();

        _.showNoStorageItems( $('section article.storage__stat').length<1 );
      } else {
        if (falsy(handleApiError(data))) _.global.alert(ALERT.FAIL_DELETE_STAT); // '현재 스탯 삭제를 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
      }

    }).catch((err) => {
      _.loading.end();

      if (falsy(handleApiError(jqXHR))) _.global.alert(ALERT.FAIL_DELETE_STAT); // '현재 스탯 삭제를 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
    });
  }

  async setStatSimulatorByApi(classId, targetLevel, idx) {
    const _ = this;

    try {
      const classDefaultStat = await getClassDefaultStat({ // 2021.01 스탯 세팅 호출 targetLevel 추가
        apiDomain: _.option.apiDomain,
        classId: classId,
        targetLevel: targetLevel
      });

      const savedUserStat = await getSavedUserStat({
        apiDomain: _.option.apiDomain,
        idx: idx
      });

      _.loading.end();

      _.showSimulatorWrap(false);

      _.showClassLayer(false);

      const viewPageData = StatModel.getSavedStatData(savedUserStat.simulationStat, savedUserStat.userStatInfo, {
        'idx': idx,
        'page': 'view',
        'type': _.model.DEVICE_TYPE,
      });

      console.log('setStatSimulatorByApi - classDefaultStat :', classDefaultStat);
      console.log('setStatSimulatorByApi - savedUserStat :', savedUserStat);

      _.setStatSimulator(viewPageData.page, savedUserStat.userStatInfo.classId, savedUserStat.userStatInfo.targetLevel,  viewPageData, classDefaultStat);

    } catch (err) {
      _.loading.end();

      if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_LOAD_SAVED_STAT); // '현재 저장된 스탯 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
    }
  }

  // 2022.01 레벨 추가
  setStatSimulator(page, classId, targetLevel, data, classDefaultStatData = null) {
    const _ = this;


    _.stat = new StatSimulator({
      staticDomain: _.option.staticDomain,
      apiDomain: _.option.apiDomain,
      classId: classId,
      // level : targetLevel,
      targetLevel : targetLevel,
      page: page, // default, view, modify
      wrap: $('.wrap-simulator-body', _.wrap),
      data: data,
      classDefaultStatData: classDefaultStatData,
      isLogin: _.option.isLogin,
      savedUserStatNum: _.getSavedUserStatNum()
    }).init();

    console.log('=> Stat.js setStatSimulator() _.stat : ' , _.stat );
    $(_.stat)
      .on(StatSimulator.EVT_CLOSE, function (evt) {
        _.destroyStatSimulator();
        _.showStorage(true);
        _.showSimulatorWrap(true);
      })
      .on(StatSimulator.EVT_SAVE_STAT_COMPLETE, function (evt) {
        _.destroyStatSimulator();
        _.setStorage();
        _.showStorage(true);
        _.showSimulatorWrap(true);
      })
      .on(StatSimulator.EVT_DELETE_STAT_COMPLETE, function (evt) {
        _.destroyStatSimulator();
        _.setStorage();
        _.showStorage(true);
        _.showSimulatorWrap(true);
      });
  }

  showSimulatorWrap(flag) {
    (truthy(flag)) ? this.simulatorWrap.show() : this.simulatorWrap.hide();
  }

  showClassLayer(flag) {
    (truthy(flag)) ? this.classLayer.show() : this.classLayer.hide();
  }

  showStorage(flag) {
    (truthy(flag)) ? this.storageWrap.show() : this.storageWrap.hide();
  }

  showNoStorageItems(flag) {
    (truthy(flag)) ? this.displayNoStorageItem.show() : this.displayNoStorageItem.hide();
    (truthy(flag)) ? $('.simulator-storage footer').hide() : $('.simulator-storage footer').show();
  }

  getDateStr(dateStr, format = 'YYYY.MM.DD') {
    return moment(dateStr).format(format);
  }

  getSavedUserStatNum() {
    return $('.storage-bundle .storage__stat', this.wrap).length;
  }

  destroyStatSimulator() {
    const _ = this;

    if (isDefined(_.stat)) {
      $(_.stat)
        .off(StatSimulator.EVT_CLOSE)
        .off(StatSimulator.EVT_SAVE_STAT_COMPLETE)
        .off(StatSimulator.EVT_DELETE_STAT_COMPLETE)

      _.stat.destroy();
      _.stat = null;
    }
  }
}

export default Stat;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/stat/Stat.js